import React from 'react';
import Loading from '../../Components/Loading';

const Authenticating = () => {
    return <div className="w-full flex flex-col items-center justify-center">
        <Loading size="2x" center />
    </div>;
}

export default Authenticating;